import { useQuery } from 'data-fetching-client';
import { PUBLIC_PRICING_PAGE_DETAILS } from 'pricing-pages-api/EarlyRequesterNames';
import { GET_PUBLIC_PRICING_PAGE_DETAILS } from 'pricing-pages-api/public-pricing-page-details/queries';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { getCountryCodeFromLocale } from '../../utils/countryCodeUtils';
export const usePublicPricingPageDetails = ({
  isAppAuth = false
}) => {
  const browserLocale = getPreferredLanguage().toLowerCase() || 'en-us';
  const preferredCountryCode = getCountryCodeFromLocale();
  const {
    data,
    error,
    loading
  } = useQuery(GET_PUBLIC_PRICING_PAGE_DETAILS, {
    variables: {
      earlyRequestName: PUBLIC_PRICING_PAGE_DETAILS,
      browserLocale,
      preferredCountryCode: preferredCountryCode ? preferredCountryCode : undefined
    },
    skip: isAppAuth
  });
  return {
    data: data === null || data === void 0 ? void 0 : data.publicPricingPageDetails,
    error,
    loading
  };
};